import React from "react";
import { Grid, Typography } from "@mui/material";
import { FeatureIconMap } from "../../search/FeatureIconMap";

const FeatureOptionItem = ( {feature} ) => {
    const FeatureIcon = FeatureIconMap[feature];

    return (
        <Grid item className='ss-location-features-option-item'>
            <FeatureIcon fontSize={'small'} htmlColor={'#7C8597'} />
            <Typography className='ss-location-features-item-name'>
                {feature}
            </Typography>
        </Grid>
    )
}

export default FeatureOptionItem;
